<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:29:22
 * @LastEditTime: 2019-08-19 03:00:03
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="pageTitle">发货管理</div>
    <el-button type="primary"
               @click="showLink=!showLink"
               style="width: 150px;height: 40px;margin: 20px"
               class="btnColor">手机端登陆地址</el-button>
    <copyLinkDialog @handleClose='showLink =false'
                    v-if="showLink" />
    <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane label="出货给经销商的记录"
                   name="2">
        <el-form ref="form"
                 :model="form"
                 label-width="100px"
                 :inline="true"
                 class="mt20">
          <el-form-item label="发货时间:"
                        style="text-align: center">
            <el-col :span="11">
              <el-date-picker type="date"
                              placeholder="开始时间"
                              v-model="form.start_time"
                              style="width: 100%;"
                              clearable></el-date-picker>
            </el-col>
            <el-col :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker type="date"
                              placeholder="结束时间"
                              v-model="form.end_time"
                              style="width: 100%;"
                              clearable></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="出货单号:">
            <el-input v-model="form.stock_out_sn"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="出货类型:">
            <el-select v-model="form.type"
                       clearable
                       placeholder="请选择">
              <el-option key=""
                         label="全部"
                         value=""></el-option>
              <el-option key="2"
                         label="订单出货"
                         value="2"></el-option>
              <el-option key="3"
                         label="调拨单发货单"
                         value="3"></el-option>
              <el-option key="4"
                         label="自建订单发货单"
                         value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select v-model="form.status"
                       clearable
                       placeholder="请选择">
              <el-option key=""
                         label="全部"
                         value=""></el-option>
              <el-option key="0"
                         label="未发货"
                         value="0"></el-option>
              <el-option key="1"
                         label="已发货"
                         value="1"></el-option>
              <el-option key="2"
                         label="发货中"
                         value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商:">
            <el-col :span="12">
              <el-input v-model="form.to_sn"
                        clearable></el-input>
            </el-col>
            <el-col :span="4"
                    style="margin-left: 10px;">
              <el-button type="primary"
                         @click="selectType()">选择</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="是否赠品:"
                        prop="region">
            <el-select clearable
                       v-model="form.isgift"
                       size="small">
              <el-option key=""
                         label="全部"
                         value=""></el-option>
              <el-option key="1"
                         label="赠品"
                         value="1"></el-option>
              <el-option key="2"
                         label="非赠品"
                         value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       @click="onSearch()">搜索</el-button>
            <el-button @click="exportData()">导出</el-button>
          </el-form-item>
        </el-form>
        <div style="margin-bottom:10px">总计录: {{total}} ,出货数:{{outstock}}</div>

        <el-table :data="tableData"
                  style="width: 100%"
                  border
                  stripe
                  v-loading="loading">

          <el-table-column width="180"
                           prop="stock_out_sn"
                           label="出货单号">
          </el-table-column>
          <el-table-column prop="to_sn"
                           label="经销商编号">
          </el-table-column>
          <el-table-column prop="to_name"
                           label="经销商名称">
          </el-table-column>
          <el-table-column prop="to_person"
                           label="负责人"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="to_address"
                           label="收货地址">
          </el-table-column>
          <el-table-column prop=""
                           label="是否赠品">
            <template slot-scope="scope">
              {{scope.row.isgift==1?"赠品":"非赠品"}}
            </template>
          </el-table-column>
          <el-table-column prop="stock_out_num"
                           label="应出货数量">
          </el-table-column>
          <el-table-column prop="real_stock_out_num"
                           label="实发数量">
          </el-table-column>
          <el-table-column width="200"
                           prop="created_at"
                           label="出货时间"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column fixed="right"
                           prop="status"
                           label="状态"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if='scope.row.status==0'>待发货</span>
              <span v-if='scope.row.status==2'>发货中</span>
              <span v-if='scope.row.status==1'>发货完成</span>

            </template>
          </el-table-column>

          <el-table-column fixed="right"
                           prop=""
                           label="操作"
                           width="180"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text"
                         size="small"
                         @click="getDetail(scope.row)">查看明细</el-button>

            </template>
          </el-table-column>

        </el-table>

        <!--分页-->
        <el-pagination style="margin: 20px 0"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageNo"
                       :page-sizes="[5, 10, 20, 50]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="totalSize">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="出货给门店的记录"
                   name="3">
        <el-form ref="form"
                 :model="form"
                 label-width="100px"
                 :inline="true"
                 class="mt20">
          <el-form-item label="发货时间:"
                        style="text-align: center">
            <el-col :span="11">
              <el-date-picker type="date"
                              placeholder="开始时间"
                              v-model="form1.start_time"
                              style="width: 100%;"
                              clearable></el-date-picker>
            </el-col>
            <el-col :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker type="date"
                              placeholder="结束时间"
                              v-model="form1.end_time"
                              style="width: 100%;"
                              clearable></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="出货单号:">
            <el-input v-model="form1.stock_out_sn"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="出货类型:">
            <el-select v-model="form1.type"
                       clearable
                       placeholder="请选择">
              <el-option key=""
                         label="全部"
                         value=""></el-option>
              <el-option key="2"
                         label="订单出货"
                         value="2"></el-option>
              <el-option key="3"
                         label="调拨单出货"
                         value="3"></el-option>
              <el-option key="4"
                         label="自建单出货"
                         value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select v-model="form1.status"
                       clearable
                       placeholder="请选择">
              <el-option key=""
                         label="全部"
                         value=""></el-option>
              <el-option key="0"
                         label="未发货"
                         value="0"></el-option>
              <el-option key="1"
                         label="已发货"
                         value="1"></el-option>
              <el-option key="2"
                         label="部分发货"
                         value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="门店:">
            <el-col :span="12">
              <el-input v-model="form1.to_sn"
                        clearable></el-input>
            </el-col>
            <el-col :span="4"
                    style="margin-left: 10px;">
              <el-button type="primary"
                         @click="selectStoreDialog=!selectStoreDialog">选择</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="是否赠品:"
                        prop="region">
            <el-select clearable
                       v-model="form1.isgift"
                       size="small">
              <el-option key=""
                         label="全部"
                         value=""></el-option>
              <el-option key="1"
                         label="赠品"
                         value="1"></el-option>
              <el-option key="2"
                         label="非赠品"
                         value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       @click="onSearch()">搜索</el-button>
            <el-button @click="exportData()">导出</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="tableData1"
                  style="width: 100%"
                  border
                  stripe
                  v-loading="loading">
          <el-table-column prop="stock_out_sn"
                           label="出货单号">
          </el-table-column>
          <el-table-column prop="to_sn"
                           label="门店编号">
          </el-table-column>
          <el-table-column prop="to_name"
                           label="门店名称">
          </el-table-column>
          <el-table-column prop="to_person"
                           label="负责人"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="to_address"
                           label="收货地址">
          </el-table-column>
          <el-table-column prop="product_specs"
                           label="是否赠品">
            <template slot-scope="scope">
              {{scope.row.isgift==1?"赠品":"非赠品"}}
            </template>
          </el-table-column>
          <el-table-column prop="stock_out_num"
                           label="应出货数量">
          </el-table-column>
          <el-table-column prop="real_stock_out_num"
                           label="实发数量">
          </el-table-column>
          <el-table-column fixed="right"
                           prop="inwarehouse_at"
                           label="出货时间"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column fixed="right"
                           prop="status"
                           label="状态"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if='scope.row.status==0'>待发货</span>
              <span v-if='scope.row.status==2'>发货中</span>
              <span v-if='scope.row.status==1'>发货完成</span>

            </template>
          </el-table-column>

          <el-table-column prop=""
                           label="操作"
                           width="180"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text"
                         size="small"
                         @click="getDetail(scope.row)">查看明细</el-button>
            </template>
          </el-table-column>

        </el-table>

        <!--分页-->
        <el-pagination style="margin: 20px 0"
                       @size-change="handleSizeChange1"
                       @current-change="handleCurrentChange1"
                       :current-page="pageNo1"
                       :page-sizes="[5, 10, 20, 50]"
                       :page-size="pageSize1"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="totalSize1">
        </el-pagination>
      </el-tab-pane>

    </el-tabs>

    <!--选择经销商/门店-->
    <selectDealer v-if="selectDealerDialog"
                  v-on:handleClose='selectDealerDialog = false'
                  @pushData="getSelectinfo">
    </selectDealer>

    <!--选择经销商/门店-->
    <selectStore v-if="selectStoreDialog"
                 v-on:handleClose='selectStoreDialog = false'
                 @pushData="getSelectstore">
    </selectStore>
    <!--批量导入-->
    <importData v-if="importDataDialog"
                v-on:handleClose='importDataDialog = false'
                @refresh="onSearch">
    </importData>
    <!--物流码明细-->
    <deliverCodeDialog v-if="deliverCodeDialog"
                       v-on:handleClose='deliverCodeDialog = false'
                       :stock_out_sn="stock_out_sn">

    </deliverCodeDialog>
    <el-dialog :visible.sync="detail"
               width="40%"
               title='查看明细'>
      <el-button size="small"
                 @click="exportDetail()"
                 style='margin-bottom:10px;'>导出明细</el-button>
      <el-table :data="tableData2"
                style="width: 100%"
                border
                stripe
                v-loading="loading"
                :default-expand-all=true>
        <el-table-column prop="stock_out_sn"
                         width="180"
                         label="出货单号">
        </el-table-column>
        <el-table-column prop="product_sn"
                         label="产品编号">
        </el-table-column>
        <el-table-column prop="product_name"
                         label="产品名称">
        </el-table-column>
        <el-table-column prop="product_specs"
                         label="产品规格"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="real_stock_out_num"
                         label="出货数量">
        </el-table-column>
        <el-table-column prop="logistics_code"
                         label="物流码">
        </el-table-column>
        <el-table-column prop="code_type"
                         label="标签类型"
                         fixed="right">
        </el-table-column>

      </el-table>
      <!--分页-->
      <!-- <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination> -->
    </el-dialog>
  </div>
</template>

<script>
import selectDealer from '@/common/selectDealer';
import importData from './importData';
import deliverCodeDialog from './deliverCode';
import selectStore from './selectStore';
import copyLinkDialog from '@/common/copyLinkDialog';

export default {
  name: "deliver-manage",
  data () {
    return {
      detail: false,
      loading: false,
      selectStoreDialog: false,
      selectDealerDialog: false,
      importDataDialog: false,
      deliverCodeDialog: false,
      showLink: false,
      activeName: '2',
      outstock: 0,
      total: 0,
      form: {
        start_time: '',
        end_time: '',
        production_batch: '',
        stock_out_sn: '',
        product_sn: '',
        product_name: '',
        warehouse_sn: '',
        status: "",
        to_sn: '',
        to_type: '',
        isgift: ""
      },
      form1: {
        start_time: '',
        end_time: '',
        production_batch: '',
        stock_out_sn: '',
        product_sn: '',
        product_name: '',
        warehouse_sn: '',
        status: "",
        to_sn: '',
        to_type: '',
        isgift: ""
      },
      stockArray: [],//仓库
      tableData: [],
      tableData1: [],
      tableData2: [],

      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      pageNo1: 1,
      pageSize1: 20,
      totalSize1: 0,
      pageNo2: 1,
      pageSize2: 20,
      totalSize2: 0,
      stock_out_sn: '',//传给物流明细
      detailData: {}
    }
  },
  methods:
  {
    getLastMonth () {
      var now = new Date();
      var year = now.getFullYear();//getYear()+1900=getFullYear()
      var month = now.getMonth() + 1;//0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + '-' + month + '-' + day;

      if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
      if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + '-' + month + '-01';
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
        return dateObj;
      } else {
        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
        return dateObj;
      }

    },
    getDetail (data) {
      this.loading = true
      this.detail = true
      this.detailData = data
      this.$get('logistics_1', '/outwarehouses/' + data.stock_out_sn + '/productdata', {
        is_export: 0
      }).then(res => {
        this.tableData2 = res.data
        this.loading = false
      })
    },
    //导出
    exportDetail () {

      let url = '', access_tokens = localStorage.getItem('access_token');


      window.open(process.env.VUE_APP_URL_V1
        + '/outwarehouses/' + this.detailData.stock_out_sn + '/productdata.export?' +
        '&lang=' + '' + '&is_export=1'
        + '&signature=' + this.$md5(access_tokens)

      )
    },
    //获取仓库
    getStock () {
      this.$get('logistics', '/warehouses.all', {
        lang: ''
      }).then(res => {
        this.stockArray = res.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    //获取选择经销商门店
    getSelectinfo (val) {
      if (val.dealer_sn) {
        this.form.to_sn = val.dealer_sn;
        this.form.to_type = 2;
      } else {

        this.form.to_type = 3;
      }
    },
    getSelectstore (val) {
      this.form1.to_sn = val.shop_sn;
    },
    //请求列表数据
    onSearch () {
      this.loading = true;
      if (this.activeName == 2) {
        if (this.form.start_time) {
          this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD");
        }
        if (this.form.end_time) {
          this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
        }
        this.$get('logistics_1', '/outwarehouses', {
          lang: '',
          channel: 1,
          is_export: 0,
          ...this.form,
          per_page: this.pageSize,
          page: this.pageNo,
          to_type: this.activeName
        }).then(res => {
          this.loading = false;
          this.tableData = res.data;
          this.totalSize = res.meta.total;
          this.total = res.count
          this.outstock = res.sum
        })

      } else {
        if (this.form1.start_time) {
          this.form1.start_time = this.moment(this.form1.start_time).format("YYYY-MM-DD");
        }
        if (this.form1.end_time) {
          this.form1.end_time = this.moment(this.form1.end_time).format("YYYY-MM-DD");
        }
        this.$get('logistics_1', '/outwarehouses', {
          lang: '',
          channel: 1,
          is_export: 0,
          ...this.form1,
          per_page: this.pageSize1,
          page: this.pageNo1,
          to_type: this.activeName
        }).then(res => {
          this.loading = false;
          this.tableData1 = res.data;
          this.totalSize1 = res.meta.total;
          this.total = res.count
          this.outstock = res.sum
        })
      }


    },
    //添加发货
    addDeliver () {
      this.$router.push({
        name: 'addDeliver'
      });
    },
    //批量导入
    importData () {
      this.importDataDialog = true;
    },
    //选择经销商/门店
    selectType () {
      this.selectDealerDialog = true;
    },
    //导出
    exportData () {

      let url = '', access_tokens = localStorage.getItem('access_token');

      if (this.activeName == 2) {
        let beginstr = '', endstr = '';
        if (this.form.start_time) {
          beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD")
        }
        if (this.form.end_time) {
          endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
        }
        var status = this.form.status ? this.form.status : ''
        var gift = this.form.isgift ? this.form.isgift : ''
        window.open(process.env.VUE_APP_URL_V1
          + '/outwarehouses.export?start_time=' + beginstr + '&end_time=' + endstr + '&channel=1&is_export=1' + '&product_sn=' +
          this.form.product_sn + '&stock_out_sn=' + this.form.stock_out_sn + '&production_batch=' + this.form.production_batch +
          '&product_name=' + this.form.product_name + '&lang=' + '' + '&warehouse_sn=' + this.form.warehouse_sn + '&to_type=' +
          this.activeName + '&to_sn=' + this.form.to_sn + '&status=' + status + '&isgift=' + gift + '&signature=' + this.$md5(access_tokens)

        )
        //    
        //       form: {
        //     start_time: '',
        //     end_time: '',
        //     production_batch: '',
        //     stock_out_sn: '',
        //     product_sn: '',
        //     product_name: '',
        //     warehouse_sn: '',
        //     status: '',
        //     to_sn: '',
        //     to_type: '',
        //     isgift: ''
        // },
      } else {
        let beginstr = '', endstr = '';
        if (this.form1.start_time) {
          beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD")
        }
        if (this.form1.end_time) {
          endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
        }
        var status = this.form1.status ? this.form1.status : ''
        var gift = this.form1.isgift ? this.form1.isgift : ''
        window.open(process.env.VUE_APP_URL_V1
          + '/outwarehouses.export?start_time=' + beginstr + '&end_time=' + endstr + '&channel=1&is_export=1' + '&product_sn=' +
          this.form1.product_sn + '&stock_out_sn=' + this.form1.stock_out_sn + '&production_batch=' + this.form1.production_batch +
          '&product_name=' + this.form1.product_name + '&lang=' + '' + '&warehouse_sn=' + this.form1.warehouse_sn + '&to_type=' +
          this.activeName + '&to_sn=' + this.form1.to_sn + '&status=' + status + '&isgift=' + gift + '&signature=' + this.$md5(access_tokens)
        )
      }

    },
    //发货标签码明细
    deliverDetail (row) {
      this.stock_out_sn = row.stock_out_sn;
      this.deliverCodeDialog = true;
    },
    //打印


    /*分页*/
    handleSizeChange (val) {

      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange (val) {
      this.pageNo = val;
      this.onSearch();
    },
    /*分页*/
    handleSizeChange1 (val) {
      this.pageSize1 = val;
      this.pageNo1 = 1;
      this.onSearch();
    },
    handleCurrentChange1 (val) {
      this.pageNo1 = val;
      this.onSearch();
    },
    /*分页*/
    handleSizeChange2 (val) {

      this.pageSize2 = val;
      this.pageNo2 = 1;
      this.getDetail();
    },
    handleCurrentChange2 (val) {
      this.pageNo2 = val;
      this.getDetail();
    },

    handleClick () {
      this.onSearch()
    }


  },
  created () {
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.form1.start_time = this.getLastMonth().last;
    this.form1.end_time = this.getLastMonth().now;
    // this.getStock();
    this.onSearch();

  },
  components: {
    selectDealer, importData, deliverCodeDialog, copyLinkDialog, selectStore
  }
}
</script>
<style lang="scss" scoped>
.tableBox {
  overflow-x: scroll;
  .table {
    width: 300%;
  }
}
</style>